module.exports = __webpack_public_path__ + "img/earlySession.ea1031f4.gif";